import gql from 'graphql-tag';

const UPGRADE_GBX = gql`
  mutation ($dExperiment: DExperiment, $wg: Boolean) {
    gbxUpgrade(dExperiment: $dExperiment, wg: $wg) {
      gbxUpgradeTransaction {
        isWithGift
        error
        errorMessage
        isPaymentDecline
      }
    }
  }
`;

export default UPGRADE_GBX;
